import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { PieceJointe } from './piece-jointe.model';
import { PieceJointeService } from './piece-jointe.service';

@Component({
    selector: 'jhi-piece-jointe-detail',
    templateUrl: './piece-jointe-detail.component.html'
})
export class PieceJointeDetailComponent implements OnInit, OnDestroy {

    pieceJointe: PieceJointe;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private pieceJointeService: PieceJointeService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load (id) {
        this.pieceJointeService.find(id).subscribe(pieceJointe => {
            this.pieceJointe = pieceJointe;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe-detail.component.ts